module.exports = __webpack_public_path__ + "img/quest_icon_0008_taptap.efdff1c2.png";